import dayjs from 'dayjs';

export interface ISubmission {
  id?: number;
  submissionDate?: dayjs.Dayjs | null;
  requestBody?: string | null;
  responseBody?: string | null;
  status?: string | null;
}

export const defaultValue: Readonly<ISubmission> = {};
